import {MLanguageCategory} from "@elte/translate-backend/interface/lang_category"
import {app, ServiceMethodsLangCategory} from './initialFethersjs';

export class LanguageApi implements MLanguageCategory.IService {
    protected endPoint: ServiceMethodsLangCategory;

    constructor() {
        this.endPoint = app.service("lang_category")
    }

    find(): Promise<MLanguageCategory.DataLanguageCategory[]> {
        return this.endPoint.find() as Promise<MLanguageCategory.DataLanguageCategory[]>;
    }



}
